import React, { useEffect } from 'react';
import Swal from 'sweetalert2';

interface UnsavedChangesGuardProps {
  isDirty: boolean;
}

export async function confirmTabSwitch(): Promise<boolean> {
  const result = await Swal.fire({
    title: 'Unsaved Changes',
    text: 'You have unsaved changes that will be lost. Continue?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Discard Changes',
    cancelButtonText: 'Stay',
    confirmButtonColor: '#d33',
  });
  return result.isConfirmed;
}

export const UnsavedChangesGuard: React.FC<UnsavedChangesGuardProps> = ({ isDirty }) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = ''; // Required for some browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty]);

  return null;
};

export default UnsavedChangesGuard;
